import React from 'react'
import MUFreeText from './MUFreeText'
import MUDropdown from './MUDropdown'
import MUSearchable from './MUSearchable'
import { FIELD_TYPE } from '../constants'

const MassUpdateValue = (props) => {

    const { translate,countryCode, fieldName, fieldValue, setFieldValue } = props

    if (fieldName?.fieldType === FIELD_TYPE.FREE_TEXT) {
        return <MUFreeText
            translate={translate}
            fieldName={fieldName}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
        />
    }
    if (fieldName?.fieldType === FIELD_TYPE.DROPDOWN) {
        return <MUDropdown
            translate={translate}
            countryCode={countryCode}
            fieldName={fieldName}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
        />
    }
    if (fieldName?.fieldType === FIELD_TYPE.SEARCHABLE) {
        return <MUSearchable
            translate={translate}
            fieldName={fieldName}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
        />
    }

    return null
}

export default MassUpdateValue